module.exports = __webpack_public_path__ + "img/invoicelist-bill.b7feae70.png";